module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ls-metric-banner"
  }, _vm._l((_vm.series), function(serie) {
    return _c('div', {
      staticClass: "metrics-banner-item"
    }, [(_vm.series.length > 1) ? _c('h5', [_vm._v(_vm._s(serie.name))]) : _c('h5'), _vm._v(" "), _c('div', {
      staticClass: "metric-value"
    }, [_vm._v(_vm._s(serie.value || '-'))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71f1e306"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/LsMetricBanner.vue
// module id = 665
// module chunks = 0